import HeaderPhoto from "./images/header-photo.jpg";
import HeaderPhoto2 from "./images/header-photo-2.jpg";

export const categories = [
  {
    id: "blouse",
    name: "Bluzy",
  },
  {
    id: "pants",
    name: "Spodnie",
  },
  {
    id: "tshirt",
    name: "T-shirt",
  },
  {
    id: "sweaters",
    name: "Swetry",
  },
  {
    id: "dresses",
    name: "Sukienki",
  },
];

export const recommendedItems = [
  "blouse-2",
  "blouse-4",
  "blouse-7",
  "pants-2",
  "tshirt-2",
  "pants-3",
  "sweater-1",
  "dress-2",
];

export const allStoreItems = [
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Episode-x-Jujutsu-Kaisen-Squad-Black-Hoodie-_350425-alt3-US.jpg",
    category: "blouse",
    id: "blouse-1",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "30",
    name: "Bluza ANIME",
    price: "859",
    stars: 3,
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Episode-x-Jujutsu-Kaisen-Squad-Black-Hoodie-_350425-front-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Episode-x-Jujutsu-Kaisen-Squad-Black-Hoodie-_350425-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Episode-x-Jujutsu-Kaisen-Squad-Black-Hoodie-_350425-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Episode-x-Jujutsu-Kaisen-Squad-Black-Hoodie-_350425-alt3-US.jpg",
    ],
    linkedItems: ["blouse-2", "blouse-3"],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/NGOrder-Ride-Or-Die-Pink-%26-Purple-Crop-Zip-Hoodie-_353965-front-US.jpg",
    category: "blouse",
    id: "blouse-2",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "30",
    name: "Różowa Bluza z czaszką",
    linkedItems: ["blouse-4", "blouse-3"],
    price: "59",
    stars: 5,
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/NGOrder-Ride-Or-Die-Pink-%26-Purple-Crop-Zip-Hoodie-_353965-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/NGOrder-Ride-Or-Die-Pink-%26-Purple-Crop-Zip-Hoodie-_353965-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/NGOrder-Ride-Or-Die-Pink-%26-Purple-Crop-Zip-Hoodie-_353965-alt2-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/NGOrder-Ride-Or-Die-Pink-%26-Purple-Crop-Zip-Hoodie-_353965-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Santa-Cruz-Once-Upon-A-Dot-Purple-Tie-Dye-Hoodie-_351609-front-US.jpg",
    category: "blouse",
    id: "blouse-3",
    sizes: ["xs/s", "s/m", "l/xl"],
    linkedItems: ["blouse-2", "blouse-4"],
    discount: "30",
    name: "Bluza Santa Cruz",
    price: "559",
    stars: 5,
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Santa-Cruz-Once-Upon-A-Dot-Purple-Tie-Dye-Hoodie-_351609-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Santa-Cruz-Once-Upon-A-Dot-Purple-Tie-Dye-Hoodie-_351609-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Santa-Cruz-Once-Upon-A-Dot-Purple-Tie-Dye-Hoodie-_351609-alt2-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Santa-Cruz-Once-Upon-A-Dot-Purple-Tie-Dye-Hoodie-_351609-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Cali-1850-Reversible-Black-Flannel-%26-Faux-Fur-Zip-Hoodie-_359126-front-US.jpg",
    category: "blouse",
    id: "blouse-4",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "30",
    name: "Dwustronna Bluza Biało Czarna",
    linkedItems: ["blouse-2", "blouse-3"],
    price: "759",
    stars: 2,
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Cali-1850-Reversible-Black-Flannel-%26-Faux-Fur-Zip-Hoodie-_359126-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Cali-1850-Reversible-Black-Flannel-%26-Faux-Fur-Zip-Hoodie-_359126-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Cali-1850-Reversible-Black-Flannel-%26-Faux-Fur-Zip-Hoodie-_359126-alt3-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Cali-1850-Reversible-Black-Flannel-%26-Faux-Fur-Zip-Hoodie-_359126-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/A-Lab-Freela-Eat-Dirt-Periwinkle-Hoodie-_351073-front-US.jpg",
    category: "blouse",
    id: "blouse-5",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "30",
    stars: 2,
    name: "Niebieska Bluza Together",
    linkedItems: ["blouse-6", "blouse-3"],
    price: "559",
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/A-Lab-Freela-Eat-Dirt-Periwinkle-Hoodie-_351073-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/A-Lab-Freela-Eat-Dirt-Periwinkle-Hoodie-_351073-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/A-Lab-Freela-Eat-Dirt-Periwinkle-Hoodie-_351073-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Vans-Drop-V-Burgundy-Hoodie-_343195-front-US.jpg",
    category: "blouse",
    id: "blouse-6",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "30",
    name: "Czerwona Bluza Vans",
    linkedItems: ["blouse-5", "blouse-3"],
    price: "259",
    stars: 3,
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Vans-Drop-V-Burgundy-Hoodie-_343195-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Vans-Drop-V-Burgundy-Hoodie-_343195-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Vans-Drop-V-Burgundy-Hoodie-_343195-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Obey-Ruby-Rose-Black-Tie-Dye-Hoodie-_352437-front-US.jpg",
    category: "blouse",
    id: "blouse-7",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "30",
    name: "Szara Bluza Okay",
    linkedItems: ["blouse-5", "blouse-3"],
    price: "159",
    stars: 4,
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Obey-Ruby-Rose-Black-Tie-Dye-Hoodie-_352437-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Obey-Ruby-Rose-Black-Tie-Dye-Hoodie-_352437-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Obey-Ruby-Rose-Black-Tie-Dye-Hoodie-_352437-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/JV-by-Jac-Vanek-Don-t-Bother-Orange-Tie-Dye-Crew-Neck-Sweatshirt-_351086-front-US.jpg",
    category: "blouse",
    id: "blouse-8",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "30",
    name: "Szara Bluza Okay",
    linkedItems: ["blouse-2", "blouse-3"],
    price: "229",
    stars: 5,
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/JV-by-Jac-Vanek-Don-t-Bother-Orange-Tie-Dye-Crew-Neck-Sweatshirt-_351086-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/JV-by-Jac-Vanek-Don-t-Bother-Orange-Tie-Dye-Crew-Neck-Sweatshirt-_351086-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/JV-by-Jac-Vanek-Don-t-Bother-Orange-Tie-Dye-Crew-Neck-Sweatshirt-_351086-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Broken-Promises-Okay-To-Cry-Purple-Crew-Neck-Sweatshirt-_354232-front-US.jpg",
    category: "blouse",
    id: "blouse-9",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "20",
    stars: 5,
    name: "Fioletowa Bluza HELL",
    linkedItems: ["blouse-1", "blouse-3"],
    price: "259",
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Broken-Promises-Okay-To-Cry-Purple-Crew-Neck-Sweatshirt-_354232-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Broken-Promises-Okay-To-Cry-Purple-Crew-Neck-Sweatshirt-_354232-alt3-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Broken-Promises-Okay-To-Cry-Purple-Crew-Neck-Sweatshirt-_354232-alt4-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Broken-Promises-Okay-To-Cry-Purple-Crew-Neck-Sweatshirt-_354232-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Obey-Love-Is-Cure-Black-Hoodie-_345691-front-US.jpg",
    category: "blouse",
    id: "blouse-10",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "15",
    name: "Czarna Bluza NO",
    linkedItems: ["blouse-1", "blouse-3"],
    price: "259",
    stars: 2,
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Obey-Love-Is-Cure-Black-Hoodie-_345691-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Obey-Love-Is-Cure-Black-Hoodie-_345691-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Obey-Love-Is-Cure-Black-Hoodie-_345691-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/RIPNDIP-Peeking-Nerm-Light-Grey-Jogger-Sweatpants-_337538-back-US.jpg",
    category: "pants",
    id: "pants-1",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "25",
    name: "Białe Spodnie Kitty",
    linkedItems: ["blouse-2"],
    price: "209",
    stars: 5,
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/RIPNDIP-Peeking-Nerm-Light-Grey-Jogger-Sweatpants-_337538-front-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/RIPNDIP-Peeking-Nerm-Light-Grey-Jogger-Sweatpants-_337538-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/RIPNDIP-Peeking-Nerm-Light-Grey-Jogger-Sweatpants-_337538-alt4-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/RIPNDIP-Peeking-Nerm-Light-Grey-Jogger-Sweatpants-_337538-back-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/NGOrder-Flame-Blue-%26-Pink-Jogger-Sweatpants-_326027-front-US.jpg",
    category: "pants",
    id: "pants-2",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "25",
    stars: 5,
    name: "Niebieskie Spodnie Blue & Pink",
    linkedItems: ["blouse-3"],
    price: "209",
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/NGOrder-Flame-Blue-%26-Pink-Jogger-Sweatpants-_326027-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/NGOrder-Flame-Blue-%26-Pink-Jogger-Sweatpants-_326027-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/NGOrder-Flame-Blue-%26-Pink-Jogger-Sweatpants-_326027-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Broken-Promises-x-Santa-Cruz-Flutter-Purple-Tie-Dye-Sweatpants-_347986-front-US.jpg",
    category: "pants",
    id: "pants-3",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "15",
    stars: 5,
    name: "Różowe Spodnie Butterfly",
    linkedItems: ["blouse-7"],
    price: "209",
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Broken-Promises-x-Santa-Cruz-Flutter-Purple-Tie-Dye-Sweatpants-_347986-alt3-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Broken-Promises-x-Santa-Cruz-Flutter-Purple-Tie-Dye-Sweatpants-_347986-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Broken-Promises-x-Santa-Cruz-Flutter-Purple-Tie-Dye-Sweatpants-_347986-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Broken-Promises-x-Santa-Cruz-Flutter-Purple-Tie-Dye-Sweatpants-_347986-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Thrasher-Flame-Logo-Black-Boyfriend-Fit-T-Shirt-_273175-front-US.jpg",
    category: "tshirt",
    id: "tshirt-1",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "15",
    name: "Czarna Koszulka Trasher",
    linkedItems: ["blouse-2", "pants-2"],
    price: "219",
    stars: 3,
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Thrasher-Flame-Logo-Black-Boyfriend-Fit-T-Shirt-_273175-alt4-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Thrasher-Flame-Logo-Black-Boyfriend-Fit-T-Shirt-_273175-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Thrasher-Flame-Logo-Black-Boyfriend-Fit-T-Shirt-_273175-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Episode-x-Jujutsu-Kaisen-Megumi-Box-Green-Tie-Dye-T-Shirt-_351284-front-US.jpg",
    category: "tshirt",
    id: "tshirt-2",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "15",
    name: "Zielona Koszulka Anime",
    linkedItems: ["blouse-4", "pants-1"],
    price: "219",
    stars: 5,
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Episode-x-Jujutsu-Kaisen-Megumi-Box-Green-Tie-Dye-T-Shirt-_351284-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Episode-x-Jujutsu-Kaisen-Megumi-Box-Green-Tie-Dye-T-Shirt-_351284-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Episode-x-Jujutsu-Kaisen-Megumi-Box-Green-Tie-Dye-T-Shirt-_351284-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Santa-Cruz-Other-Dot-Black-T-Shirt--_319218-front-US.jpg",
    category: "tshirt",
    id: "tshirt-3",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "45",
    name: "Czarna Koszulka Santa Cruz",
    linkedItems: ["blouse-5", "pants-3"],
    price: "219",
    stars: 5,
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Santa-Cruz-Other-Dot-Black-T-Shirt--_319218-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Santa-Cruz-Other-Dot-Black-T-Shirt--_319218-alt2-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Santa-Cruz-Other-Dot-Black-T-Shirt--_319218-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Ragged-Jeans-Enlightened-Black-%26-Pink-Hooded-Zip-Sweater-_350466-front-US.jpg",
    category: "sweaters",
    id: "sweater-1",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "45",
    stars: 5,
    name: "Czarny Sweter Fire",
    linkedItems: ["blouse-1", "pants-2"],
    price: "219",
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Ragged-Jeans-Enlightened-Black-%26-Pink-Hooded-Zip-Sweater-_350466-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Ragged-Jeans-Enlightened-Black-%26-Pink-Hooded-Zip-Sweater-_350466-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Ragged-Jeans-Enlightened-Black-%26-Pink-Hooded-Zip-Sweater-_350466-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Ragged-Jeans-Buddy-Hearts-Purple-%26-Black-Crew-Neck-Knit-Sweater-_350469-front-US.jpg",
    category: "sweaters",
    id: "sweater-2",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "45",
    name: "Czarny Sweter W Kratę",
    linkedItems: ["blouse-7", "pants-1"],
    price: "219",
    stars: 5,
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Ragged-Jeans-Buddy-Hearts-Purple-%26-Black-Crew-Neck-Knit-Sweater-_350469-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Ragged-Jeans-Buddy-Hearts-Purple-%26-Black-Crew-Neck-Knit-Sweater-_350469-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Ragged-Jeans-Buddy-Hearts-Purple-%26-Black-Crew-Neck-Knit-Sweater-_350469-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Daisy-Street-Flower-Tan-Crop-Cardigan-Sweater-_348750-front-US.jpg",
    category: "sweaters",
    id: "sweater-3",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "45",
    name: "Sweter w Kwiatki",
    linkedItems: ["blouse-9", "pants-2"],
    price: "219",
    stars: 2,
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Daisy-Street-Flower-Tan-Crop-Cardigan-Sweater-_348750-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Daisy-Street-Flower-Tan-Crop-Cardigan-Sweater-_348750-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Daisy-Street-Flower-Tan-Crop-Cardigan-Sweater-_348750-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Empyre-Dia-Brown-Plaid-Mini-Dress-_344506-front-US.jpg",
    category: "dresses",
    id: "dress-1",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "15",
    name: "Sukienka w Kratę",
    linkedItems: ["blouse-1", "sweater-1"],
    price: "219",
    stars: 5,
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Empyre-Dia-Brown-Plaid-Mini-Dress-_344506-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Empyre-Dia-Brown-Plaid-Mini-Dress-_344506-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Empyre-Dia-Brown-Plaid-Mini-Dress-_344506-front-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Empyre-Dia-Brown-Plaid-Mini-Dress-_344506-alt2-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/SWIXXZ-Lightning-Black-Bodycon-Dress-_348008-front-US.jpg",
    category: "dresses",
    id: "dress-2",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "15",
    name: "Sukienka Storm",
    linkedItems: ["blouse-1", "sweater-1"],
    price: "219",
    stars: 4,
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/SWIXXZ-Lightning-Black-Bodycon-Dress-_348008-alt2-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/SWIXXZ-Lightning-Black-Bodycon-Dress-_348008-back-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/SWIXXZ-Lightning-Black-Bodycon-Dress-_348008-front-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
  {
    image:
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Lurking-Class-by-Sketchy-Tank-Black%2C-White-%26-Red-Stripe-Mock-Neck-Dress-_344579-front-US.jpg",
    category: "dresses",
    id: "dress-3",
    sizes: ["xs/s", "s/m", "l/xl"],
    discount: "15",
    name: "Sukienka w Paski",
    linkedItems: ["blouse-5", "sweater-2"],
    price: "219",
    stars: 4,
    images: [
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Lurking-Class-by-Sketchy-Tank-Black%2C-White-%26-Red-Stripe-Mock-Neck-Dress-_344579-alt1-US.jpg",
      "https://scene7.zumiez.com/is/image/zumiez/product_main_medium_2x/Lurking-Class-by-Sketchy-Tank-Black%2C-White-%26-Red-Stripe-Mock-Neck-Dress-_344579-back-US.jpg",
    ],
    longDescription:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis mollis nunc, eget feugiat risus. Donec dictum sit amet mi at blandit. Vestibulum aliquam tempus placerat. Quisque facilisis rhoncus libero, id rhoncus ante eleifend vel. Sed consectetur vel nunc eget tempus. Vestibulum viverra dignissim odio, ut venenatis risus bibendum aliquet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In sollicitudin sem ex, ac pellentesque nibh porta eget. Maecenas vehicula bibendum augue sed fringilla. Mauris pretium posuere augue eget eleifend. Suspendisse eu metus ligula. Donec tempor ante et nibh semper posuere.",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tempor dolor in imperdiet suscipit. Quisque magna justo, ullamcorper vitae suscipit ac, maximus in neque. Donec ante mauris, vulputate a urna sit amet, finibus sollicitudin turpis.",
  },
];

export const homePageItems = [
  {
    image:
      "https://images.unsplash.com/photo-1478118012687-899ed7b11f61?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    name: "Sweter FIFI",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut mauris augue, finibus in mauris nec, tincidunt aliquet eros. Donec gravida euismod turpis in lobortis. Vivamus feugiat vitae enim in tempor. ",
  },
  {
    image:
      "https://images.unsplash.com/photo-1502163140606-888448ae8cfe?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    name: "Kurtka Jeansowa FIFI",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut mauris augue, finibus in mauris nec, tincidunt aliquet eros.",
  },
  {
    image:
      "https://images.unsplash.com/photo-1509003124559-eb6678fe452b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    name: "Spodnie Jeansowe FIFI",
    description:
      "Morbi imperdiet consequat porttitor. Vestibulum eu convallis mi. Duis finibus ante ut neque condimentum pretium. Phasellus eu fermentum dolor, sit amet sollicitudin leo",
  },
];

export const upcomingItems = [
  {
    image: HeaderPhoto,
    name: "Okulary FIFI STORE",
    id: 1,
  },
  {
    image: HeaderPhoto2,
    name: "Bluza Calvin Klein",
    id: 2,
  },
];
